import {forwardRef} from "react";
import {Box, BoxProps, Select, Text, Tooltip} from "@mantine/core";
import {IconQuestionMark} from "@tabler/icons-react";

type TimezoneSelectorProps = {
    /**
     * The selected timezone name
     */
    selectedZone?: string
    onChange: (selectedZone: string) => void
} & BoxProps

// @ts-ignore
const timeZones: Array<string> = Intl.supportedValuesOf("timeZone")
const americaZones: Array<string> = timeZones.filter((tz) => tz.startsWith("America/"))
const europeZones: Array<string> = timeZones.filter((tz) => tz.startsWith("Europe/"))
const usedZones = [...americaZones, ...europeZones].sort((a, b) => a.slice(a.indexOf("/") + 1) > b.slice(b.indexOf("/") + 1) ? 1 : -1)

export const TimezoneSelector = forwardRef<HTMLDivElement, TimezoneSelectorProps>(({
                                                                                       selectedZone,
                                                                                       onChange,
                                                                                       className,
                                                                                       ...others
                                                                                   }: TimezoneSelectorProps, ref) => {


    const getLabelComponent = () => {
        const label = <Text> All times entered are relative to the selected timezone.</Text>
        return (
            <span>
                Timezone
            <Tooltip position={"right-end"} withArrow label={label}>
                <IconQuestionMark color={"blue"} size={16}/>
            </Tooltip>
            </span>
        )
    }

    return (
        <Box ref={ref} {...others}>
            <Select className={className}
                    data-testid={"select-timezone"}
                    label={getLabelComponent()}
                    labelProps={{style: {textAlign: "center", width: "100%"}}}
                    data={usedZones}
                    defaultValue={selectedZone ? selectedZone : null}
                    onChange={(value ) => value && onChange(value)}
            />
        </Box>
    )
})